import Avatar from '-/Custom/Avatar';
import { StyleSheet, View } from 'react-native';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import { graphql, type ResultOf } from '@/gql/graphql';
import formatMessageDatetime from '@/utils/formatMessageDatetime';

const ChatMessageHeaderFragment = graphql(/* GraphQL */ `
  fragment ChatMessageHeader on message {
    id
    createdAt: created_at
    creator {
      id
      name
      avatarId: avatar_id
      avatarColor: color
    }
  }
`);

function ChatMessageHeader({
  name,
  createdAt,
  avatarId,
  avatarColor,
}: {
  name: string;
  createdAt: ResultOf<typeof ChatMessageHeaderFragment>['createdAt'];
  avatarId: ResultOf<typeof ChatMessageHeaderFragment>['creator']['avatarId'];
  avatarColor: ResultOf<
    typeof ChatMessageHeaderFragment
  >['creator']['avatarColor'];
}) {
  return (
    <>
      <View style={style.avatar}>
        <Avatar name={name} color={avatarColor} id={avatarId || ''} />
      </View>
      <Box
        space="md"
        direction="horizontal"
        alignItems="center"
        marginLeft={48}
      >
        <Text>{name}</Text>
        <Text variant="typographySecondary" size="xs">
          {formatMessageDatetime(createdAt)}
        </Text>
      </Box>
    </>
  );
}

const style = StyleSheet.create({
  avatar: {
    position: 'absolute',
    left: 8,
    top: 0,
    margin: 'auto',
    height: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});

export default ChatMessageHeader;
